import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Page } from 'components';
import React from 'react';
import {
  Header,
  NewProjects,
  OrderManagementList,
  RoiPerCustomer,
  SystemHealth,
  TodaysMoney
} from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  container: {
    marginTop: theme.spacing(3)
  }
}));

const DashboardDefault = () => {
  const classes = useStyles();
  const account = JSON.parse(localStorage.getItem('user'));

  return (
    <Page className={classes.root} title="OnSocial">
      <Header profile={account} />
      <Grid className={classes.container} container spacing={3}>
        <Grid item lg={3} sm={6} xs={12}>
          <RoiPerCustomer />
        </Grid>
        <Grid item lg={3} sm={6} xs={12}>
          <TodaysMoney />
        </Grid>
        <Grid item lg={3} sm={6} xs={12}>
          <SystemHealth />
        </Grid>
        <Grid item lg={3} sm={6} xs={12}>
          <NewProjects />
        </Grid>

        <Grid item lg={12} xs={12}>
          <OrderManagementList />
        </Grid>
      </Grid>
    </Page>
  );
};

export default DashboardDefault;
